<div [class.hidden]="!show">
    <div [ngClass]="['loader-overlay-top']">
        <div class="loader"></div>
    </div>
</div>
<div [class.hidden]="!show" id="app-spinner" class="spinner-border text-info" role="status">
    <span class="sr-only">Loading...</span>
</div>

